import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorSubSampling';

export class ColorSubSampling extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
